import { createSelector } from 'reselect';
import { getLatestActivitySet } from 'lib/selectors/getLatestActivitySet';
import { getHasOpenActivitySet } from 'lib/selectors/getHasOpenActivitySet';
import { getPostLaborUpdatesOnNats } from 'lib/selectors/getPostLaborUpdatesOnNats';

const getIsLatestActivitySetOpen = createSelector(
  [getLatestActivitySet, getHasOpenActivitySet, getPostLaborUpdatesOnNats],
  (latestActivitySet, hasOpenActivitySet, natsFlowEnabled) => {
    if (natsFlowEnabled) {
      // Use the shared selector here because synthetic NATS sets do not have a real activitySetRef.
      return hasOpenActivitySet;
    }
    return !!(
      latestActivitySet?.activitySetRef && !latestActivitySet?.closedAt
    );
  }
);

export { getIsLatestActivitySetOpen };
